var map = {
	"./de_DE.json": [
		8365,
		8365
	],
	"./en-US.json": [
		1408,
		1408
	],
	"./es.json": [
		3350,
		3350
	],
	"./fr_FR.json": [
		5859,
		5859
	],
	"./nl-NL.json": [
		8417,
		8417
	],
	"./ru-RU.json": [
		5379,
		5379
	],
	"./tr-TR.json": [
		2717,
		2717
	],
	"./zh-CN.json": [
		5282,
		5282
	],
	"./zh-Hans.json": [
		815,
		815
	],
	"./zh.json": [
		7336,
		7336
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5951;
module.exports = webpackAsyncContext;